

import Vue from 'vue'
import Component from "vue-class-component";
import {namespace} from "vuex-class";
import {IOnOffHandlers} from "bonomo/dist";
import {Prop} from "vue-property-decorator";
import {IErrors} from "@/model/IErrors";
import {IContract, IRenewData} from "@/model/Contract/contractInterfaces";
import BoDateField from "@/components/shared/BoDateField.vue";

const lockerContractModule = namespace("lockerContractModule");


@Component({
  components: {BoDateField}
})
export default class ContractRenewDialog extends Vue {
  @Prop()
  private show!: boolean;
  @lockerContractModule.Getter('contract')
  private contract!: IContract;

  @lockerContractModule.Action('renewContract')
  private renewContract!: (myObj: any) => void;

  @lockerContractModule.Action('clearErrors')
  private clearErrors!: () => void;

  @lockerContractModule.Getter('errors')
  private errors!: IErrors;

  private subscribes: IOnOffHandlers = {};

  private loading: boolean = false;

  private data: IRenewData = {
    contract_id: null,
    locker_id: null,
    renovation_notice_date: '',
    end_contract_date: '',
    last_renovation_date: '',
    IPC_increase_date: '',
  };

  created() {
    this.subscribes = this.$ons({
      'backend.call.OK.contractLoaded': this.onContractLoadedOK,
      'backend.call.KO.contractLoaded': this.onContractLoadedKO,
      'backend.call.OK.contractRenewed': this.onContractRenewedOK,
      'backend.call.KO.contractRenewed': this.onContractRenewedKO,
    });
  }

  beforeDestroy() {
    this.$offs(this.subscribes);
  }

  private onContractLoadedOK() {
    this.loading = false;
    this.data.contract_id = this.contract.id ? this.contract.id:0;
    this.data.locker_id = this.contract.locker_id;
    this.data.renovation_notice_date = this.contract.renovation_notice_date ? this.contract.renovation_notice_date:'';
    this.data.end_contract_date = this.contract.end_contract_date ? this.contract.end_contract_date:'';
    this.data.last_renovation_date = this.contract.last_renovation_date ? this.contract.last_renovation_date:'';
    this.data.IPC_increase_date = this.contract.IPC_increase_date ? this.contract.IPC_increase_date:'';
  }

  private onContractRenewedOK() {
    this.loading = false;
    this.clearErrors();
    this.$emit('close');
    this.$router.push({ name: 'lockersContract', params: {lockerId: ''+this.contract.locker_id, entityId: ''+this.contract.id}});
  }

  private onContractLoadedKO() {
    this.loading = false;
  }
  private onContractRenewedKO() {
    this.loading = false;
  }

  private onClose() {
    this.$emit('close');
    this.clearErrors();
  }

  private onRenew() {
    this.loading = true;
    this.renewContract(this.data);
  }

  private get canSubmit() {
    return this.data.renovation_notice_date != this.contract.renovation_notice_date &&
    this.data.end_contract_date != this.contract.end_contract_date &&
    this.data.last_renovation_date != this.contract.last_renovation_date &&
    this.data.IPC_increase_date != this.contract.IPC_increase_date;
  }
}
